import HubSpotBot from "components/Chatbot/Chatbot";
import { BrowserRouter } from "react-router-dom";
import MyRouter from "routers/index";

function App() {
  return (
    <div className="bg-white text-base dark:bg-[#000000] text-neutral-900 dark:text-neutral-200">
      {/* <HubSpotBot /> */}

      <MyRouter />
    </div>
  );
}

export default App;
